export default __webpack_public_path__ + "static/media/jamal_2.7353c587.jpg";